//	L I B S

import { lib_names } from '../libs/lib.names';

//	T Y P E S

import { type___api___response } from '../types/type.api';

//	E X P O R T

export class service_RestApiService {

//#region 																							D E C L A R A T I O N S

	private _HEADERS: any = { 'Content-Type': 'application/json' };

//#endregion

//#region 																							R E T U R N   S E R V E R   R E S P O N S E

	private async return_server_response(___target: string, ___to_post: any | {} = {}) : Promise<any> {
		const ___s_route: string = lib_names.endpoints.server_api + ___target;
		try {
			const ___s_response: Response = await fetch(___s_route, { method: 'POST', headers: this._HEADERS, body: JSON.stringify(___to_post) });
			if (___s_response.ok) {
				try {
					const ___server_response: any = await ___s_response.json();
					return (___server_response !== null && ___server_response !== undefined) ? ___server_response : { response: 'error', message: 'response-error', data: null };
				} catch (___e: any) {
					return { response: 'error', message: 'api-error', data: null };
				}
			} else {
				return { response: 'error', message: 'api-error', data: null };
			}
		} catch (___e_main: any) {
			console.error('Error fetching server response:', ___e_main);
			return { response: 'error', message: 'api-error', data: null };
		}
	}

//#endregion

//#region 																							R E A D   M E N U

	async public___read_menu(___target: 'vanity' | 'id', ___digitalmenu_vanity: string) : Promise<type___api___response> {
		const ___to_post: any = { 'target': ___target, 'param': ___digitalmenu_vanity };
		return await this.return_server_response('read_menu', ___to_post)
	}

//#endregion

//#region 																							R E A D   D I S H

	async public___read_dish(___dish_id: string) : Promise<type___api___response> {
		const ___to_post: any = { 'dish_id': ___dish_id };
		return await this.return_server_response('read_dish', ___to_post)
	}

//#endregion

//#region 																							R E A D   A L L E R G E N S

	async public___read_allergens() : Promise<type___api___response> {
		const ___to_post: any = { };
		return await this.return_server_response('read_allergens', ___to_post)
	}

//#endregion

}